import React from 'react';

interface DateSeparatorProps {
  /**
   * Date label (e.g., "Today", "Yesterday", "January 15, 2024")
   */
  label: string;
}

/**
 * DateSeparator Component
 * Displays date divider between messages like Slack
 */
const DateSeparator: React.FC<DateSeparatorProps> = ({ label }) => {
  return (
    <div className="flex items-center gap-4 my-4 px-6">
      <div className="flex-1 h-px bg-[#EDEDED]" />
      <span className="font-manrope font-medium text-xs text-[#757575] px-3 py-1 bg-white border border-[#EDEDED] rounded-full">
        {label}
      </span>
      <div className="flex-1 h-px bg-[#EDEDED]" />
    </div>
  );
};

export default DateSeparator;
